import { groupBy } from 'lodash';
import { AlertMetricsByMedium, GraphQLAlertMetric } from '../types';
import { useAlertMetricsQuery } from './useAlertMetricsQuery';

export const getSortedAlertMetrics = (initialResults: GraphQLAlertMetric[]) => {
  return groupBy(
    initialResults,
    (alertMetric) => alertMetric.mediums[0],
  ) as unknown as AlertMetricsByMedium;
};

export const useGetAlertMetrics = (options?: Record<string, any>) => {
  const { results: metrics, isLoading: isLoadingMetrics } = useAlertMetricsQuery(options);

  return {
    allAlertMetrics: getSortedAlertMetrics(metrics),
    isLoadingMetrics,
  };
};
